// ==========================
// src/pages/Signup.js
// ==========================
import { Form, Input, Button, Card, message } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { auth, googleProvider } from "../firebase";
import { signInWithPopup } from "firebase/auth";

export default function Signup() {
  const navigate = useNavigate();

  const onFinish = async (values) => {
    const { fullName, email, password, confirmPassword } = values;

    if (password !== confirmPassword) {
      message.error("Passwords do not match");
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );

      await updateProfile(userCredential.user, {
        displayName: fullName,
      });

      message.success("Signup successful!");
      navigate("/dashboard");
    } catch (error) {
      message.error(error.message);
    }
  };

  const signupWithGoogle = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
      message.success("Google Signup successful!");
      navigate("/dashboard");
    } catch (error) {
      message.error(error.message);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f5f5f5",
      }}
    >
      {/* Navbar */}
      <div
        style={{
          background: "#1677ff",
          color: "white",
          padding: "12px 30px",
          display: "flex",
          justifyContent: "space-between",
          fontSize: "20px",
          fontWeight: "bold",
        }}
      >
        <span>Financely.</span>
        <span style={{ fontSize: "14px", cursor: "pointer" }}>
          Logout
        </span>
      </div>

      {/* Signup Card */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingTop: "70px",
        }}
      >
        <Card
          style={{
            width: 420,
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
        >
          <h2
            style={{
              textAlign: "center",
              marginBottom: "30px",
              fontWeight: "500",
            }}
          >
            Sign Up on{" "}
            <span style={{ color: "#1677ff" }}>Financely.</span>
          </h2>

          <Form layout="vertical" onFinish={onFinish}>
            <Form.Item
              label="Full Name"
              name="fullName"
              rules={[{ required: true, message: "Enter full name" }]}
            >
              <Input placeholder="John Doe" />
            </Form.Item>

            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, message: "Enter email" }]}
            >
              <Input placeholder="JohnDoe@gmail.com" />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: "Enter password" }]}
            >
              <Input.Password placeholder="Example@123" />
            </Form.Item>

            <Form.Item
              label="Confirm Password"
              name="confirmPassword"
              rules={[
                { required: true, message: "Confirm your password" },
              ]}
            >
              <Input.Password placeholder="Example@123" />
            </Form.Item>

            <Button
              htmlType="submit"
              block
              style={{
                marginTop: "10px",
                borderColor: "#1677ff",
                color: "#1677ff",
              }}
            >
              Signup Using Email and Password
            </Button>

            <div
              style={{
                textAlign: "center",
                margin: "15px 0",
                fontSize: "16px",
              }}
            >
              or
            </div>

            <Button
              type="primary"
              block
              onClick={signupWithGoogle}
            >
              Signup Using Google
            </Button>

            <p
              style={{
                textAlign: "center",
                marginTop: "20px",
              }}
            >
              Already have an account?{" "}
              <Link to="/login">Login</Link>
            </p>
          </Form>
        </Card>
      </div>
    </div>
  );
}